import { render, staticRenderFns } from "./PendingEditRequestListValues.vue?vue&type=template&id=7f27f0c4&scoped=true&"
import script from "./PendingEditRequestListValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestListValues.vue?vue&type=script&lang=js&"
import style0 from "./PendingEditRequestListValues.vue?vue&type=style&index=0&id=7f27f0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27f0c4",
  null
  
)

export default component.exports